import type { ReactNode } from 'react'
import { ChevronDownIcon } from './icons.js'

export interface DisclosureRowProps {
  label: string
  value: ReactNode
  onOpen: () => void
}

/**
 * A decided answer with a way in — "Valgymas: Pietūs", "Gaminimas: Žalias".
 * Shows what was chosen for you and opens the full choice only when touched,
 * so the common case costs zero taps and the correction costs one.
 */
export function DisclosureRow({ label, value, onOpen }: DisclosureRowProps) {
  return (
    <button
      type="button"
      onClick={onOpen}
      className="flex h-11 w-full select-none items-center justify-between rounded-[var(--radius-control)] border border-line px-3 text-left transition-colors duration-[140ms] active:bg-raised"
    >
      <span className="text-sm text-mute">{label}</span>
      <span className="flex items-center gap-1.5 text-base text-ink">
        {value}
        <ChevronDownIcon className="size-4 text-mute" />
      </span>
    </button>
  )
}
